// src/components/CtaBanner.jsx
import { motion } from "framer-motion";
import { FaPhoneAlt, FaPaperPlane } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function CtaBanner() {
  const navigate = useNavigate();

  return (
    <motion.section
      className="relative mx-auto max-w-6xl px-6 py-16"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      {/* softer background glow */}
      <div className="absolute inset-0 -z-10 rounded-3xl bg-gradient-to-br from-blue-700 via-indigo-600 to-emerald-600 opacity-20" />

      {/* softened glass card */}
      <div className="relative rounded-3xl bg-white/12 backdrop-blur-sm border border-white/20 shadow-lg text-center px-6 py-12">
        <h2 className="text-3xl md:text-4xl font-extrabold text-white">
          Glide Into Your Future 🚀
        </h2>
        <p className="mt-3 text-white/90 max-w-2xl mx-auto">
          One conversation can shape your journey. Let’s connect and map your best pathway today.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">
          {/* solid button */}
          <button
            onClick={() => navigate("/contact")}
            className="inline-flex items-center justify-center gap-2 rounded-xl bg-emerald-500 text-white px-6 py-3 font-semibold shadow hover:bg-emerald-600 transition"
          >
            <FaPaperPlane /> Talk to Us
          </button>

          {/* outlined button */}
          <a
            href="tel:+61403883559"
            className="inline-flex items-center justify-center gap-2 rounded-xl border border-white/50 text-white px-6 py-3 font-semibold hover:bg-white/10 transition"
          >
            <FaPhoneAlt /> Call Now
          </a>
        </div>

        <p className="mt-6 text-sm text-white/75">
          Fast responses • Personalised guidance • 7+ years experience
        </p>
      </div>
    </motion.section>
  );
}
